import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <header className="w-full h-16 flex items-center px-4 md:px-6 border-b border-background-200">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
            51
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950">51网址导航</span>
        </Link>
      </header>

      <main className="flex-1 w-full flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-[560px]">
          <p className="font-heading font-extrabold text-6xl md:text-8xl text-primary-100">404</p>
          <h1 className="mt-2 font-heading font-bold text-xl md:text-2xl text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-2 text-sm text-foreground-500 leading-6">
            链接可能已经失效，或者网址输入有误。你可以返回首页，或者从分类里重新找一个入口。
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2">
            <Link
              to="/"
              className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search?q=%E8%A7%86%E9%A2%91"
              className="px-4 py-2 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              去搜索网站
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}